import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { FiSearch } from 'react-icons/fi';
import { FaShip } from 'react-icons/fa'; // Ship icon
import { fetchExportedStores } from './api';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  flex-grow: 1;
  width: 100%;
  overflow: hidden;
  background-color: #f4f4f4;

 @media (max-width: 768px) {
    padding: 10px;
  }  
  
`;

const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 10px;
  }  
`;

const Title = styled.h1`
  color: #1c4e8c;
  font-size: 28px;
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: 22px;
  }  
`;

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  background: white;
  padding: 10px;
  width: 70%;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;

  @media (max-width: 768px) {
    width: 95%;
    padding: 8px;
  }  
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  text-align: center;
  outline: none;

  @media (max-width: 768px) {
    padding: 8px;
    font-size: 14px;
  }  
`;

const SearchIcon = styled(FiSearch)`
  font-size: 22px;
  color: #1c4e8c;
  margin-right: 10px;

  @media (max-width: 768px) {
    font-size: 18px;
  }  
`;


const WarehouseGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr)); /* Adjust column count */
  gap: 15px;
  width: 79%;
  height: calc(100vh - 150px);
  overflow-y: auto;
  padding: 20px;
  border: 2px solid #1c4e8c;
  border-radius: 10px;
  background-color: white;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 1024px) { 
    grid-template-columns: repeat(3, 1fr); /* 3 per row on tablets */
    width: 95%;
  }

  @media (max-width: 768px) { 
    grid-template-columns: repeat(2, 1fr); /* 2 per row on mobile */
    padding: 10px;
    border-width: 1px;
    height: auto;
  }  

`;

const WarehouseCard = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  text-align: center;
  border: 2px solid #1c4e8c;
  width: 100%; /* Takes full width inside grid */
  height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  transition: transform 0.2s, box-shadow 0.2s;
  overflow: hidden;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    background-color: #1c4e8c;
    color: white;

    svg {
      color: white;
    }
  }

  @media (max-width: 768px) {
    height: 80px;
  }
`;


// const WarehouseGrid = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   justify-content: center;
//   gap: 15px;
//   width: 79%;
//   height: calc(100vh - 150px);
//   overflow-y: auto;
//   padding: 20px;
//   border: 2px solid #1c4e8c; /* Blue border */
//   border-radius: 10px; /* Rounded corners */
//   background-color: white; /* Background color to keep it separate */
//   box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow for better visibility */

//   @media (max-width: 768px) {
//     width: 95%;
//     padding: 10px;
//     border-width: 1px;
//     height: auto;
//     min-height: 60vh;
//   }  
// `;


// const WarehouseCard = styled.div`
//   background: white;
//   padding: 15px;
//   border-radius: 12px;
//   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
//   cursor: pointer;
//   text-align: center;
//   border: 2px solid #1c4e8c;
//   width: 220px; /* Fixed width */
//   height: 100px; /* Increased height for better spacing */
//   display: flex;
//   flex-direction: column; /* Stack items vertically */
//   align-items: center;
//   justify-content: center;
//   gap: 5px;
//   transition: transform 0.2s, box-shadow 0.2s;
//   overflow: hidden;

//   &:hover {
//     transform: translateY(-5px);
//     box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
//     background-color: #1c4e8c;
//     color: white;

//     svg {
//       color: white; /* Change icon color on hover */
//     }
//   }

//   @media (max-width: 768px) {
//     width: 90%;
//     height: 80px;
//     padding: 10px;
//   }  
// `;

const ShipIcon = styled(FaShip)`
  font-size: 26px; /* Slightly larger */
  color: #1c4e8c;
  flex-shrink: 0;
  transition: color 0.2s;

  @media (max-width: 768px) {
    font-size: 22px;
  }  
`;

/* Keeps text centered below the icon */
const WarehouseText = styled.span`
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  max-width: 160px;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  line-height: 1.2;
  white-space: normal;

  @media (max-width: 768px) {
    font-size: 14px;
    max-width: 140px;
  }  
`;


const ToggleRow = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  direction: rtl;
`;

const ToggleButton = styled.button`
  padding: 10px 22px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 25px;
  cursor: pointer;
  transition: 0.25s;
  border: 2px solid #1c4e8c;
  background: ${({ active }) => (active ? 'linear-gradient(135deg, #1c4e8c, #4a90e2)' : 'white')};
  color: ${({ active }) => (active ? 'white' : '#1c4e8c')};

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 8px 16px;
  }
`;

const ExportBadge = styled.span`
  background: ${({ sailed }) => (sailed ? '#7f8c8d' : '#e67e22')};
  color: white;
  font-size: 11px;
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 10px;
  white-space: nowrap;
`;

const EmptyMessage = styled.div`
  padding: 30px;
  font-size: 18px;
  color: #1c4e8c;
  text-align: center;
  width: 100%;
`;

// WCF returns dates as "/Date(1752400000000+0300)/"
const parseDotNetDate = (str) => {
  const match = str?.match(/\d+/);
  if (!match) return '';
  return new Date(parseInt(match[0])).toLocaleDateString('he-IL');
};

const WarehouseList = ({ userData }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [viewMode, setViewMode] = useState('regular'); // 'regular' | 'export'
  const [exportedBoats, setExportedBoats] = useState(null); // null = not loaded yet

  useEffect(() => {
    if (viewMode === 'export' && exportedBoats === null && userData?.Cust_Code) {
      fetchExportedStores(userData.Cust_Code).then((data) => {
        setExportedBoats(data || []);
      });
    }
  }, [viewMode, exportedBoats, userData?.Cust_Code]);

  if (!userData) {
    return <h2>טוען נתונים...</h2>;
  }

  const filteredWarehouses = userData.Warehouses
  .filter(warehouse =>
    warehouse.Store_Name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    warehouse.Store_Code.toString().includes(searchTerm)
  )
  .sort((a, b) => b.Store_Code - a.Store_Code);

  const filteredExported = (exportedBoats || [])
    .filter(boat =>
      (boat.Store_Name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (boat.Store_Code || '').toString().includes(searchTerm)
    )
    .sort((a, b) => b.Store_Code - a.Store_Code);

  const isExport = viewMode === 'export';

  return (
    <Container>
      <HeaderSection>
        <Title>{isExport ? 'אוניות יצוא' : 'בחר אוניה'}</Title>
      </HeaderSection>

      <ToggleRow>
        <ToggleButton active={!isExport} onClick={() => setViewMode('regular')}>
          🚢 אוניות
        </ToggleButton>
        <ToggleButton active={isExport} onClick={() => setViewMode('export')}>
          📦 אוניות יצוא
        </ToggleButton>
      </ToggleRow>

      <SearchContainer>
        <SearchIcon />
        <SearchInput
          type="text"
          placeholder="🔍 חפש לפי שם אוניה או מספר אוניה"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </SearchContainer>

      <WarehouseGrid>
        {!isExport && filteredWarehouses.map((warehouse) => (
          <WarehouseCard key={warehouse.Store_Code} onClick={() => navigate(`/inventory/${warehouse.Store_Code}`)}>
            <ShipIcon />
            <WarehouseText>
              {warehouse.Store_Name} ({warehouse.Store_Code})
            </WarehouseText>
          </WarehouseCard>
        ))}

        {isExport && exportedBoats === null && (
          <EmptyMessage>טוען אוניות יצוא...</EmptyMessage>
        )}

        {isExport && exportedBoats !== null && filteredExported.length === 0 && (
          <EmptyMessage>אין אוניות יצוא</EmptyMessage>
        )}

        {isExport && filteredExported.map((boat) => (
          <WarehouseCard key={boat.Store_Code} onClick={() => navigate(`/inventory/${boat.Store_Code}`)}>
            <ShipIcon />
            <WarehouseText>
              {boat.Store_Name} ({boat.Store_Code})
            </WarehouseText>
            {boat.ExportedDate ? (
              <ExportBadge sailed>יצאה {parseDotNetDate(boat.ExportedDate)}</ExportBadge>
            ) : (
              <ExportBadge>פתוחה לטעינה</ExportBadge>
            )}
          </WarehouseCard>
        ))}
      </WarehouseGrid>
    </Container>
  );
};

export default WarehouseList;
